export default {
      id: "video-request_event-usage",
      viewBox: "0 0 25 22",
      url: __webpack_public_path__ + "img/icons.svg#video-request_event",
      toString: function () {
        return this.url;
      }
    }